import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CloudwatchService} from "../../services";
import {Subscription} from "rxjs";
import {MatTableDataSource} from "@angular/material/table";
import {
  Config,
  getConfig,
  getSelectedBusinessUnit,
  initialConfigState,
  initialThemeState,
  Theme, toggleLoading
} from "../../../redux";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort, Sort} from "@angular/material/sort";
import {IBusinessUnit} from "../../../business-units/models";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {MatDialog} from "@angular/material/dialog";
import {ISnsLog} from "../../models";

@Component({
  selector: 'app-cloudwatch-sns-log',
  templateUrl: './cloudwatch-sns-log.component.html',
  styleUrls: ['./cloudwatch-sns-log.component.scss']
})
export class CloudwatchSnsLogComponent implements OnInit, OnDestroy {

  config$: Subscription = new Subscription();
  lookup$: Subscription = new Subscription();
  selectedBusinessUnit$: Subscription = new Subscription();

  dataSource: MatTableDataSource<ISnsLog> = new MatTableDataSource();
  config: Config = initialConfigState;
  theme: Theme = initialThemeState;
  columnsToDisplay = ['user', 'number', 'message', 'status', 'time'];

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  offset: string = (new Date().getTimezoneOffset()).toString();

  selectedBusinessUnit: IBusinessUnit = {} as unknown as IBusinessUnit;

  dataList: ISnsLog[] = [];
  sortedDataList: ISnsLog[] = [];

  constructor(private cloudwatch: CloudwatchService,
              private toastr: ToastrService,
              private router: Router,
              private store: Store,
              private dialog: MatDialog) {

    this.config$ = this.store.select(getConfig).subscribe((config: Config) => {
      this.config = config;
    });

    this.selectedBusinessUnit$ = this.store.select(getSelectedBusinessUnit).subscribe((bu: IBusinessUnit) => {
      this.selectedBusinessUnit = Object.assign({}, bu);
      if (!!this.selectedBusinessUnit && !!this.selectedBusinessUnit.businessUnitId) {
        this.subscribeToDatasource();
      }
    });

  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.config$.unsubscribe();
    this.selectedBusinessUnit$.unsubscribe();
  }

  subscribeToDatasource(): void {
    console.log("Fetching SNS Log...");
    this.getSnsLog();
  }

  getSnsLog() {
    this.store.dispatch(toggleLoading({loading: true}));
    this.cloudwatch.getSnsLog().subscribe({
      next: (res: ISnsLog[]) => {
        this.dataList = res;
        this.dataSource = new MatTableDataSource(res);
        this.initDataSource();
        this.store.dispatch(toggleLoading({loading: false}));
      }, error: (err: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Something went wrong!");
      }
    });
  }

  initDataSource() {
    this.dataSource.filterPredicate = (data: ISnsLog, filter: string) => {
      const lc_filter = filter.toLowerCase();
      const name = data.appUserMiniModel?.firstName + ' ' + data.appUserMiniModel?.lastName;
      const nameMatch = name.toLowerCase().includes(lc_filter);
      const ts = data.notification.timestamp.toLowerCase().includes(lc_filter);
      const dest = data.delivery.destination.toLowerCase().includes(lc_filter);
      const stat = data.status.toLowerCase().includes(lc_filter);
      const msg = data.delivery.providerResponse.toLowerCase().includes(lc_filter);

      return nameMatch || ts || dest || stat || msg;
    };
    if (!!this.paginator) {
      this.paginator.pageSize = 100;
      this.dataSource.paginator = this.paginator;
    }
    if (!!this.sort) {
      this.dataSource.sort = this.sort;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //sort
  sortData(sort: Sort) {
    const data = this.dataList.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedDataList = data;
      return;
    }

    this.sortedDataList = data.sort((a: ISnsLog, b: ISnsLog) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'time':
          return compare(a.notification.timestamp || '', b.notification.timestamp || '', isAsc);
        case 'user':
          const u1 = a.appUserMiniModel.firstName + ' ' + a.appUserMiniModel.lastName;
          const u2 = b.appUserMiniModel.firstName + ' ' + b.appUserMiniModel.lastName;
          return compare(u1 || '', u2 || '', isAsc);
        case 'number':
          return compare(a.delivery.destination || '', b.delivery.destination || '', isAsc);
        case 'status':
          return compare(a.status || '', b.status || '', isAsc);
        case 'message':
          return compare(a.delivery.providerResponse || '', b.delivery.providerResponse || '', isAsc);
        default:
          return 0;
      }
    });

    this.dataSource = new MatTableDataSource(this.sortedDataList);
    this.initDataSource();
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
